// Переменные для рекламы из adfox.
// Должны добавляться в window.
import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';
import { defineStore } from 'pinia';

export type AdfoxParams = {
  lh_adfox_homepage: boolean;
  lh_adfox_rtn: boolean;
  lh_adfox_noad: string;
  lh_adfox_noadsense: string;
  lh_adfox_pk: string;
  lh_adfox_postid: string;
  lh_adfox_streams: string;
  lh_adfox_tags: string;
  lh_adfox_terms: string;
};

export const useAdfoxStore = wrapPiniaStore(
  defineStore('adfox', {
    state: () => ({
      currentAdfox: {
        lh_adfox_homepage: true,
        lh_adfox_rtn: false,
        lh_adfox_noad: '',
        lh_adfox_noadsense: '',
        lh_adfox_pk: '',
        lh_adfox_postid: '',
        lh_adfox_streams: '',
        lh_adfox_tags: '',
        lh_adfox_terms: '',
      } as AdfoxParams,
    }),

    actions: {
      setAdfoxParams(adfoxParams: AdfoxParams) {
        this.currentAdfox = adfoxParams;
      },
    },
  }),
);
